import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import isChromatic from 'chromatic/isChromatic';

const TEST_KEY = 'pk_test_AV6v2MnAECsJGc7Vnj3SWTY5';

// This decorator is a bit problematic as it requires communication with stripe,
// which is unreliable in tests/chromatic. The mocked version does not,
// but will render the credit card form incorrectly.
//
// The solution is as follows:
//
//  1. In the real SB, use the real decorator always
//  2. In Chromatic, use the mocked decorator by default, but override it with the
//     unmocked version on stories where you can see the CC form.

let realStripePromise;
const getRealStripePromise = () => {
  if (!realStripePromise) {
    // See line 26 for more information about why we do this here.
    realStripePromise = import('@stripe/stripe-js').then(({ loadStripe }) => loadStripe(TEST_KEY));
    return realStripePromise;
  }
  return realStripePromise;
};

/**
 * Create the Stripe decorator, deferring the actual import of the stripe library until after the
 * random number generator has had a chance to be seeded.
 *
 * This seems kind of strange that we do this this way, but Stripe utilizes the random number generator
 * upon importing the library. This waits until after we've seeded the `Math.random()` library before
 * using it, so that all calls will be predictable.
 */
export const makeStripeDecorator =
  (mockIfChromatic = false) =>
  (Story) => {
    let stripePromise;
    if (mockIfChromatic && (isChromatic() || import.meta.env.STORYBOOK_ENV === 'test')) {
      stripePromise = Promise.resolve(null);
    } else {
      stripePromise = getRealStripePromise();
    }
    return (
      <Elements stripe={stripePromise}>
        <Story />
      </Elements>
    );
  };
